import { InjectionToken } from '@angular/core';

export const PRELOAD = new InjectionToken<object>('PRELOAD');
